import { getAutoshipMaxSavings } from '@libs/common-next';
import { AUTOSHIP_RECURRING_ORDERS_DISCOUNT } from '@libs/core';

type GetAutoshipDrawerDiscountMessageParams = {
    isFirstAutoshipEligible: boolean;
    discountDisplay: string;
};

type AutoshipDrawerDiscountMessage = {
    discount: string;
    maxSavings: string;
};

export const getAutoshipDrawerDiscountMessage = ({
    isFirstAutoshipEligible,
    discountDisplay,
}: GetAutoshipDrawerDiscountMessageParams): AutoshipDrawerDiscountMessage => {
    const maxSavings = getAutoshipMaxSavings();
    const isReturningAutoshipCustomer = !isFirstAutoshipEligible;

    const discount = isReturningAutoshipCustomer ? AUTOSHIP_RECURRING_ORDERS_DISCOUNT : discountDisplay.trim();

    return { discount, maxSavings };
};
